import React from "react";

import { Tutorials } from "../../features";

const TutorialsPage = () => <Tutorials />;

export default TutorialsPage;
